import script from "./DetailsLOCV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsLOCV1.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsLOCV1.vue?vue&type=style&index=0&id=4c24da26&scoped=true&lang=css"
import "@/assets/css/application-details/student.css?vue&type=style&index=1&id=4c24da26&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c24da26"]])

export default __exports__